const convertValuesToArrays = (object: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) =>
      Array.isArray(value) ? [key, value] : [key, [value]]
    )
  );

export default convertValuesToArrays;
